// Helpers de formato consistente en zona horaria Europe/Madrid.
// La app es para peritaciones en España: las horas deben verse igual desde
// cualquier dispositivo (móvil, VPN, etc.). Forzamos timezone fijo.

const TZ = "Europe/Madrid";

export function fmtDateTime(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("es-ES", {
      timeZone: TZ,
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return String(value); }
}

export function fmtTime(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("es-ES", {
      timeZone: TZ,
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return String(value); }
}

export function fmtDate(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("es-ES", {
      timeZone: TZ,
      day: "2-digit", month: "2-digit", year: "numeric",
    });
  } catch { return String(value); }
}
